import React from "react";
import HeaderFour from "../../components/Header/HeaderFour";
import SpecialityDetailsMain from "./SpecialityDetailsMain";
import Footer from "../../components/Footer";

const SpecialityDetails = () => {
  return (
    <>
      <HeaderFour />
      <SpecialityDetailsMain />
      <Footer />
    </>
  );
};

export default SpecialityDetails;
